<main>
        <div class="contenedor">
            <!-- Header del proyecto -->
            <section class="header-proyecto">
                <div class="imagen-proyecto" style="background-image: url('https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766896995/Gemini_Generated_Image_e4bxwse4bxwse4bx-processed_lightpdf.com_vxa10x.png');"></div>
                <div class="titulo-con-flecha">
                    <a routerLink="/portafolio" class="btn-regreso">
                        <img src="assets/svg/flecha.svg" alt="Regresar">
                    </a>
                    <h1 class="titulo-proyecto">Proyecto Alto Piura</h1>
                </div>
                <div class="cuadro_ubicacion">
                    <div class="ubicacion-proyecto">
                    <span class="icono-ubicacion"><img src="assets/svg/IconoMap.svg" alt=""></span>
                        Piura
                    </div>
                </div>
                
            </section>

            <!-- Sección de información del proyecto -->
            <section class="seccion-info-proyecto">
                <div class="grid-info">
                    <div class="info-columna">
                        <h3>Importancia</h3>
                        <p>Obra hidráulica estratégica para el agro y la seguridad hídrica del norte del país. Permitirá irrigar más de 50 mil hectáreas y potenciar la generación de energía hidroeléctrica.</p>
                    </div>
                    <div class="separador-vertical"></div>
                    <div class="info-columna">
                        <h3>Descripción del proyecto</h3>
                        <p>Incluye una presa derivadora, un túnel de trasvase de 13.3 km y obras complementarias. El proyecto está a cargo del consorcio liderado por Camargo Correa.</p>
                    </div>
                </div>
            </section>

            <!-- Sección de participación -->
            <section class="seccion-participacion">
                <div class="contenido-participacion">
                    <div class="circulo-azul-decorativo"></div>
                    <div class="info-participacion">
                        <h2>Participación de Corporación Rehobot</h2>
                        <p>Se ejecutaron trabajos orientados a garantizar el <strong>abastecimiento del recurso hídrico</strong> para el campamento y los procesos constructivos de la obra en ejecución, incluyendo el <strong>replanteo del pozo improductivo</strong> y la optimización del sistema de distribución.</p>
                    </div>
                    <div class="imagen-participacion"></div>
                </div>
            </section>

            <!-- Sección de actividades -->
            <section class="seccion-actividades">
                <h2 class="actividades-titulo">Actividades <span>desarrolladas.</span></h2>
                <div class="contenido-actividades">
                    <div class="tarjeta-actividad">
                    </div>
                    <div class="tarjeta-lista-actividades">
                        <ul class="lista-actividades">
                            <li><strong>Perforación y equipamiento de un pozo tubular</strong>, asegurando un suministro eficiente.</li>
                            <li><strong>Implementación de la red de línea de conducción</strong> para el abastecimiento del recurso hídrico.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <!-- Sección más proyectos -->
            <section class="seccion-mas-proyectos">
              <div class="divisor-linea"></div>
              <h2 class="mas-proyectos-titulo">Más <span>proyectos.</span></h2>

              <div class="grid-mas-proyectos">
                <div class="tarjeta-obra-mini" *ngFor="let obra of proyectosRecomendados">
                  <div class="imagen-obra-mini"
                       [style.backgroundImage]="'url(' + obra.imagen + ')'">
                  </div>
                  <div class="contenido-mini">
                    <h3>{{ obra.titulo }}</h3>
                    <a [routerLink]="obra.link" class="btn-conoce-mas">Conoce más</a>
                  </div>
                </div>
              </div>
            </section>
        </div>
    </main>